import * as R from "ramda"
import moment from "moment"
import React from "react"
import ReactPixel from "react-facebook-pixel"
import { Button, Image, Modal } from "semantic-ui-react"
import styled from "styled-components"
import { firePixel } from "../../api/async/participants/index"

const StyledButton = styled(Button)`
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    margin-top: 10px !important;
    width: 100%;
  }
`

export const EbibButton = ({ participant, fluid }) => (
  <Modal
    trigger={
      <StyledButton
        fluid={fluid ? true : null}
        color="teal"
        onClick={() => {
          if (!participant.fire_pixel && document !== "undefined") {
            firePixel(participant)
            ReactPixel.track("Purchase", {
              value: R.path(
                ["value"],
                R.pathOr([], ["participant", "payment"], participant)[0]
              ),
              currency: "THB"
            })
          }
        }}
      >
        E-BIB ของฉัน
      </StyledButton>
    }
  >
    <Modal.Header>E-BIB</Modal.Header>
    <Modal.Content>
      <Modal.Description>
        {participant.bib ? (
          <Image wrapped fluid src={participant.bib} />
        ) : (
          <h2>กำลังสร้าง E-bib</h2>
        )}
        <div style={{ textAlign: "center" }}>
          {R.path(["bib_date"], participant) && (
            <h3 style={{ marginTop: 10 }}>
              วัน/เวลา E-BIB :
              {moment(R.path(["bib_date"], participant)).format(
                "DD/MM/YYYY HH:mm:ss"
              )}
            </h3>
          )}
          <a href={participant.bib} download>
            <Button color="teal" className="mt10">
              Download
            </Button>
          </a>
        </div>
      </Modal.Description>
    </Modal.Content>
  </Modal>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/organisms/EbibButton/index.js